<template>
  <div>
    <b-field label="Tutor Code:">
      <b-input
        placeholder="tutor-code-12345678-1234-1234-1234-123456789abc"
        v-model="tutorCode"
      />
    </b-field>
    <p v-if="invalidCodeFormat" class="is-size-7 has-text-danger">
      Invalid code. Make sure you copy/paste the whole code.
    </p>
    <b-button
      @click="connectToTutor"
      type="is-primary"
      :loading="connectingToTutor"
      expanded
    >
      Connect
    </b-button>
    <p v-if="connectingToTutorFailed" class="is-size-7 has-text-danger">
      Could not connect to tutor. Most likely the code is incorrect. Please
      check with the person who provided you with the code.
    </p>
    <br />
    <p class="is-size-7">
      Connecting to a tutor allows them to follow your progress and provide
      feedback on items that you choose to share with them. You can disconnect
      at any time.
    </p>
    <br />
    <p v-if="loadingTutors">Loading tutors information...</p>
    <p
      v-if="!loadingTutors && tutors.length === 0"
      class="has-text-grey has-text-centered"
    >
      Currently, you are not connected to any tutors
    </p>
    <div
      class="box has-text-centered is-centered"
      v-for="tutor in tutors"
      :key="tutor.tutorCode"
    >
      <div class="tutor-code">
        <code class="has-text-black">{{ tutor.tutorCode }}</code>
      </div>
      <div class="tutor-code">
        <p><b>Tutor email:</b> {{ tutor.email }}</p>
      </div>
      <b-button
        type="is-danger"
        size="is-small"
        @click="disconnectClick(tutor.tutorCode, tutor.email)"
        :loading="disconnectingCode[tutor.tutorCode]"
      >
        Disconnect
      </b-button>
      <p
        v-if="disconnectingFailed[tutor.tutorCode]"
        class="is-size-7 has-text-danger"
      >
        Failed to disconnect.
      </p>
    </div>
  </div>
</template>

<script>
import dataService from "../../services/dataService";
export default {
  data() {
    return {
      tutorCode: undefined,
      invalidCodeFormat: false,
      connectingToTutor: false,
      connectingToTutorFailed: false,
      loadingTutors: false,
      tutors: [],
      tutorCodeToDisconnect: undefined,
      disconnectingCode: {}, // per tutor code
      disconnectingFailed: {} // per tutor code
    };
  },
  methods: {
    async fetchTutors() {
      this.loadingTutors = true;
      this.tutors = await dataService.getTutors();
      this.loadingTutors = false;
    },
    async connectToTutor() {
      this.connectingToTutorFailed = false;
      this.tutorCode = this.tutorCode.trim();
      this.invalidCodeFormat = !this.validTutorCodeFormat();
      if (this.invalidCodeFormat) return;
      this.connectingToTutor = true;
      const success = await dataService.connectToTutor(this.tutorCode);
      if (success) {
        await this.fetchTutors();
        this.tutorCode = undefined;
      }
      this.connectingToTutorFailed = !success;
      this.connectingToTutor = false;
    },
    validTutorCodeFormat() {
      return (
        this.tutorCode &&
        this.tutorCode.length === 47 &&
        this.tutorCode.indexOf("tutor-code-") === 0
      );
    },
    async disconnect() {
      this.$set(this.disconnectingCode, this.tutorCodeToDisconnect, true);
      const success = await dataService.disconnectFromTutor(
        this.tutorCodeToDisconnect
      );
      this.$set(this.disconnectingFailed, this.tutorCodeToDisconnect, !success);
      if (success) await this.fetchTutors();
      this.$set(this.disconnectingCode, this.tutorCodeToDisconnect, false);
    },
    async disconnectClick(code, tutorEmail) {
      this.tutorCodeToDisconnect = code;
      this.$buefy.dialog.confirm({
        message: `You are about to disconnect from ${tutorEmail}. Do you wish to continue?`,
        onConfirm: async () => await this.disconnect()
      });
    }
  },
  async created() {
    await this.fetchTutors();
  }
};
</script>

<style lang="scss" scoped>
.tutor-code {
  padding-bottom: 15px;
}
</style>
